import {hasCookieConsentMarketing, loadVimeoAPI} from "../Utils/Utils";

const WPBlockVimeoEmbed = (blockElem, autoEmbedOnLoad) => {

	const vimeoId = blockElem.getAttribute('data-src');
	if(!vimeoId) {
		return;
	}

	let player = null;
	const placeholder = blockElem.querySelector('.placeholder');
	const poster = blockElem.querySelector('.poster');
	poster.addEventListener('click', (e) => {
		e.preventDefault();

		const consentGiven = hasCookieConsentMarketing();

		if(!consentGiven) {

			// Use this if we're going to show an "alert" instead
			const cookieAlert = blockElem.querySelector('.cookie-alert-video');
			if(cookieAlert) {
				cookieAlert.classList.add('js-revealed');
			}
			else {
				if(vimeoId.includes('http')) {
					window.open(vimeoId);
				}
				else {
					window.open(`https://vimeo.com/${vimeoId}`);
				}
			}
		}
		else {
			loadVideo();
		}
	});

	const loadVideo = () => {

		blockElem.classList.add('js-playing');

		if(player) {
			player.play();
		}
		else {
			loadVimeoAPI(() => {
				const options = {
					id: vimeoId,
					width: 640,
					height: 360,
					autoplay: true,
					byline: false,
					color: '878955',
					portrait: false,
					title: false,
				};

				player = new Vimeo.Player(placeholder.getAttribute('id'), options);
				player.on('ended', hideVideo);
			})
		}
	};

	const hideVideo = () => {
		blockElem.classList.remove('js-playing');
	};

	if(autoEmbedOnLoad) {
		loadVideo();
	}
};

export default WPBlockVimeoEmbed;